// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call/call_responses.proto (package com.gem.vcs.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { BooleanResponse } from '../common/common_responses_pb';
import { file_common_common_responses } from '../common/common_responses_pb';
import type {
  CallError_ChannelDoesntExist,
  CallError_HasNoPermissionsForActionOnCall,
  CallError_HasNoPermissionsForCall,
  CallError_HasNoPermissionsToFinishCallForAll,
  CallError_ParticipantLimitReached,
  CallError_PermissionRequestAlreadySent,
  CallError_WaitingRoomRequestDoesntExist,
  CallError_WaitingRoomRequestWasRejected,
} from './call_errors_pb';
import { file_call_call_errors } from './call_errors_pb';
import type {
  Call,
  CallInfo,
  CallMember,
  CallPermissions,
  MemberWithCustomPermissions,
  PersonalizedCallPermissions,
} from './call_model_pb';
import { file_call_call_model } from './call_model_pb';

/**
 * Describes the file call/call_responses.proto.
 */
export const file_call_call_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_common_common_responses, file_call_call_model, file_call_call_errors]
  );

/**
 * @generated from message com.gem.vcs.contract.CreateCallResponse
 */
export type CreateCallResponse = Message<'com.gem.vcs.contract.CreateCallResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.CreateCallResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CreateCallSuccess success = 1;
         */
        value: CreateCallSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.CreateCallResponse.
 * Use `create(CreateCallResponseSchema)` to create a new message.
 */
export const CreateCallResponseSchema: GenMessage<CreateCallResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 0);

/**
 * @generated from message com.gem.vcs.contract.CreateCallSuccess
 */
export type CreateCallSuccess = Message<'com.gem.vcs.contract.CreateCallSuccess'> & {
  /**
   * @generated from field: com.gem.vcs.contract.CallInfo call = 1;
   */
  call?: CallInfo;
};

/**
 * Describes the message com.gem.vcs.contract.CreateCallSuccess.
 * Use `create(CreateCallSuccessSchema)` to create a new message.
 */
export const CreateCallSuccessSchema: GenMessage<CreateCallSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 1);

/**
 * @generated from message com.gem.vcs.contract.CreateConferenceResponse
 */
export type CreateConferenceResponse = Message<'com.gem.vcs.contract.CreateConferenceResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.CreateConferenceResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CreateConferenceSuccess success = 1;
         */
        value: CreateConferenceSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.CreateConferenceResponse.
 * Use `create(CreateConferenceResponseSchema)` to create a new message.
 */
export const CreateConferenceResponseSchema: GenMessage<CreateConferenceResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 2);

/**
 * @generated from message com.gem.vcs.contract.CreateConferenceSuccess
 */
export type CreateConferenceSuccess = Message<'com.gem.vcs.contract.CreateConferenceSuccess'> & {
  /**
   * @generated from field: com.gem.vcs.contract.CallInfo call = 1;
   */
  call?: CallInfo;
};

/**
 * Describes the message com.gem.vcs.contract.CreateConferenceSuccess.
 * Use `create(CreateConferenceSuccessSchema)` to create a new message.
 */
export const CreateConferenceSuccessSchema: GenMessage<CreateConferenceSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 3);

/**
 * @generated from message com.gem.vcs.contract.JoinToCallResponse
 */
export type JoinToCallResponse = Message<'com.gem.vcs.contract.JoinToCallResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.JoinToCallResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.JoinToCallSuccess success = 1;
         */
        value: JoinToCallSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallError.ParticipantLimitReached participantLimitReached = 3;
         */
        value: CallError_ParticipantLimitReached;
        case: 'participantLimitReached';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.JoinToCallResponse.
 * Use `create(JoinToCallResponseSchema)` to create a new message.
 */
export const JoinToCallResponseSchema: GenMessage<JoinToCallResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 4);

/**
 * @generated from message com.gem.vcs.contract.JoinToCallSuccess
 */
export type JoinToCallSuccess = Message<'com.gem.vcs.contract.JoinToCallSuccess'> & {
  /**
   * @generated from field: com.gem.vcs.contract.CallInfo call = 1;
   */
  call?: CallInfo;
};

/**
 * Describes the message com.gem.vcs.contract.JoinToCallSuccess.
 * Use `create(JoinToCallSuccessSchema)` to create a new message.
 */
export const JoinToCallSuccessSchema: GenMessage<JoinToCallSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 5);

/**
 * @generated from message com.gem.vcs.contract.FinishForAllResponse
 */
export type FinishForAllResponse = Message<'com.gem.vcs.contract.FinishForAllResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.FinishForAllResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsToFinishCallForAll hasNoPermissionsToFinishCallForAll = 3;
         */
        value: CallError_HasNoPermissionsToFinishCallForAll;
        case: 'hasNoPermissionsToFinishCallForAll';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.FinishForAllResponse.
 * Use `create(FinishForAllResponseSchema)` to create a new message.
 */
export const FinishForAllResponseSchema: GenMessage<FinishForAllResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 6);

/**
 * @generated from message com.gem.vcs.contract.DeclineCallResponse
 */
export type DeclineCallResponse = Message<'com.gem.vcs.contract.DeclineCallResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.DeclineCallResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.DeclineCallResponse.
 * Use `create(DeclineCallResponseSchema)` to create a new message.
 */
export const DeclineCallResponseSchema: GenMessage<DeclineCallResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 7);

/**
 * @generated from message com.gem.vcs.contract.KickMemberResponse
 */
export type KickMemberResponse = Message<'com.gem.vcs.contract.KickMemberResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.KickMemberResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.KickMemberResponse.
 * Use `create(KickMemberResponseSchema)` to create a new message.
 */
export const KickMemberResponseSchema: GenMessage<KickMemberResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 8);

/**
 * @generated from message com.gem.vcs.contract.ForceMuteResponse
 */
export type ForceMuteResponse = Message<'com.gem.vcs.contract.ForceMuteResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.ForceMuteResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.ForceMuteResponse.
 * Use `create(ForceMuteResponseSchema)` to create a new message.
 */
export const ForceMuteResponseSchema: GenMessage<ForceMuteResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 9);

/**
 * @generated from message com.gem.vcs.contract.GetCallMembersResponse
 */
export type GetCallMembersResponse = Message<'com.gem.vcs.contract.GetCallMembersResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.GetCallMembersResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallMembersSuccess success = 1;
         */
        value: GetCallMembersSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.GetCallMembersResponse.
 * Use `create(GetCallMembersResponseSchema)` to create a new message.
 */
export const GetCallMembersResponseSchema: GenMessage<GetCallMembersResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 10);

/**
 * @generated from message com.gem.vcs.contract.GetCallMembersByCameraOrScreenIdsResponse
 */
export type GetCallMembersByCameraOrScreenIdsResponse =
  Message<'com.gem.vcs.contract.GetCallMembersByCameraOrScreenIdsResponse'> & {
    /**
     * @generated from oneof com.gem.vcs.contract.GetCallMembersByCameraOrScreenIdsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.vcs.contract.GetCallMembersByCameraOrScreenIdsSuccess success = 1;
           */
          value: GetCallMembersByCameraOrScreenIdsSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
           */
          value: CallError_HasNoPermissionsForCall;
          case: 'hasNoPermissionsForCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.vcs.contract.GetCallMembersByCameraOrScreenIdsResponse.
 * Use `create(GetCallMembersByCameraOrScreenIdsResponseSchema)` to create a new message.
 */
export const GetCallMembersByCameraOrScreenIdsResponseSchema: GenMessage<GetCallMembersByCameraOrScreenIdsResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 11);

/**
 * @generated from message com.gem.vcs.contract.GetCallMembersByCameraOrScreenIdsSuccess
 */
export type GetCallMembersByCameraOrScreenIdsSuccess =
  Message<'com.gem.vcs.contract.GetCallMembersByCameraOrScreenIdsSuccess'> & {
    /**
     * @generated from field: repeated com.gem.vcs.contract.CallMember members = 1;
     */
    members: CallMember[];
  };

/**
 * Describes the message com.gem.vcs.contract.GetCallMembersByCameraOrScreenIdsSuccess.
 * Use `create(GetCallMembersByCameraOrScreenIdsSuccessSchema)` to create a new message.
 */
export const GetCallMembersByCameraOrScreenIdsSuccessSchema: GenMessage<GetCallMembersByCameraOrScreenIdsSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 12);

/**
 * @generated from message com.gem.vcs.contract.GetCallMembersByIdsResponse
 */
export type GetCallMembersByIdsResponse =
  Message<'com.gem.vcs.contract.GetCallMembersByIdsResponse'> & {
    /**
     * @generated from oneof com.gem.vcs.contract.GetCallMembersByIdsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.vcs.contract.GetCallMembersByIdsSuccess success = 1;
           */
          value: GetCallMembersByIdsSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
           */
          value: CallError_HasNoPermissionsForCall;
          case: 'hasNoPermissionsForCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.vcs.contract.GetCallMembersByIdsResponse.
 * Use `create(GetCallMembersByIdsResponseSchema)` to create a new message.
 */
export const GetCallMembersByIdsResponseSchema: GenMessage<GetCallMembersByIdsResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 13);

/**
 * @generated from message com.gem.vcs.contract.GetCallMembersByIdsSuccess
 */
export type GetCallMembersByIdsSuccess =
  Message<'com.gem.vcs.contract.GetCallMembersByIdsSuccess'> & {
    /**
     * @generated from field: repeated com.gem.vcs.contract.CallMember members = 1;
     */
    members: CallMember[];
  };

/**
 * Describes the message com.gem.vcs.contract.GetCallMembersByIdsSuccess.
 * Use `create(GetCallMembersByIdsSuccessSchema)` to create a new message.
 */
export const GetCallMembersByIdsSuccessSchema: GenMessage<GetCallMembersByIdsSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 14);

/**
 * @generated from message com.gem.vcs.contract.GetCallMembersSuccess
 */
export type GetCallMembersSuccess = Message<'com.gem.vcs.contract.GetCallMembersSuccess'> & {
  /**
   * @generated from field: repeated com.gem.vcs.contract.CallMember members = 1;
   */
  members: CallMember[];

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;
};

/**
 * Describes the message com.gem.vcs.contract.GetCallMembersSuccess.
 * Use `create(GetCallMembersSuccessSchema)` to create a new message.
 */
export const GetCallMembersSuccessSchema: GenMessage<GetCallMembersSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 15);

/**
 * @generated from message com.gem.vcs.contract.GetCallPermissionsResponse
 */
export type GetCallPermissionsResponse =
  Message<'com.gem.vcs.contract.GetCallPermissionsResponse'> & {
    /**
     * @generated from oneof com.gem.vcs.contract.GetCallPermissionsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.vcs.contract.GetCallPermissionsSuccess success = 1;
           */
          value: GetCallPermissionsSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.vcs.contract.GetCallPermissionsResponse.
 * Use `create(GetCallPermissionsResponseSchema)` to create a new message.
 */
export const GetCallPermissionsResponseSchema: GenMessage<GetCallPermissionsResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 16);

/**
 * @generated from message com.gem.vcs.contract.GetCallPermissionsSuccess
 */
export type GetCallPermissionsSuccess =
  Message<'com.gem.vcs.contract.GetCallPermissionsSuccess'> & {
    /**
     * @generated from field: com.gem.vcs.contract.PersonalizedCallPermissions personalized = 1;
     */
    personalized?: PersonalizedCallPermissions;

    /**
     * @generated from field: com.gem.vcs.contract.CallPermissions default = 2;
     */
    default?: CallPermissions;

    /**
     * @generated from field: com.gem.vcs.contract.PersonalizedCallPermissions defaultPersonalized = 3;
     */
    defaultPersonalized?: PersonalizedCallPermissions;

    /**
     * @generated from field: repeated com.gem.vcs.contract.MemberWithCustomPermissions membersWithCustomPermissions = 4;
     */
    membersWithCustomPermissions: MemberWithCustomPermissions[];
  };

/**
 * Describes the message com.gem.vcs.contract.GetCallPermissionsSuccess.
 * Use `create(GetCallPermissionsSuccessSchema)` to create a new message.
 */
export const GetCallPermissionsSuccessSchema: GenMessage<GetCallPermissionsSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 17);

/**
 * @generated from message com.gem.vcs.contract.SetCallPermissionsForAllResponse
 */
export type SetCallPermissionsForAllResponse =
  Message<'com.gem.vcs.contract.SetCallPermissionsForAllResponse'> & {
    /**
     * @generated from oneof com.gem.vcs.contract.SetCallPermissionsForAllResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.vcs.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.vcs.contract.SetCallPermissionsForAllResponse.
 * Use `create(SetCallPermissionsForAllResponseSchema)` to create a new message.
 */
export const SetCallPermissionsForAllResponseSchema: GenMessage<SetCallPermissionsForAllResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 18);

/**
 * @generated from message com.gem.vcs.contract.SetCallPermissionsForMemberResponse
 */
export type SetCallPermissionsForMemberResponse =
  Message<'com.gem.vcs.contract.SetCallPermissionsForMemberResponse'> & {
    /**
     * @generated from oneof com.gem.vcs.contract.SetCallPermissionsForMemberResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.vcs.contract.SetCallPermissionsForMemberSuccess success = 1;
           */
          value: SetCallPermissionsForMemberSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.vcs.contract.SetCallPermissionsForMemberResponse.
 * Use `create(SetCallPermissionsForMemberResponseSchema)` to create a new message.
 */
export const SetCallPermissionsForMemberResponseSchema: GenMessage<SetCallPermissionsForMemberResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 19);

/**
 * @generated from message com.gem.vcs.contract.SetCallPermissionsForMemberSuccess
 */
export type SetCallPermissionsForMemberSuccess =
  Message<'com.gem.vcs.contract.SetCallPermissionsForMemberSuccess'> & {
    /**
     * @generated from field: com.gem.vcs.contract.PersonalizedCallPermissions personalized = 1;
     */
    personalized?: PersonalizedCallPermissions;
  };

/**
 * Describes the message com.gem.vcs.contract.SetCallPermissionsForMemberSuccess.
 * Use `create(SetCallPermissionsForMemberSuccessSchema)` to create a new message.
 */
export const SetCallPermissionsForMemberSuccessSchema: GenMessage<SetCallPermissionsForMemberSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 20);

/**
 * @generated from message com.gem.vcs.contract.ClearPermissionsForMemberResponse
 */
export type ClearPermissionsForMemberResponse =
  Message<'com.gem.vcs.contract.ClearPermissionsForMemberResponse'> & {
    /**
     * @generated from oneof com.gem.vcs.contract.ClearPermissionsForMemberResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.vcs.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.vcs.contract.ClearPermissionsForMemberResponse.
 * Use `create(ClearPermissionsForMemberResponseSchema)` to create a new message.
 */
export const ClearPermissionsForMemberResponseSchema: GenMessage<ClearPermissionsForMemberResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 21);

/**
 * @generated from message com.gem.vcs.contract.CreatePermissionRequestResponse
 */
export type CreatePermissionRequestResponse =
  Message<'com.gem.vcs.contract.CreatePermissionRequestResponse'> & {
    /**
     * @generated from oneof com.gem.vcs.contract.CreatePermissionRequestResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.vcs.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.PermissionRequestAlreadySent permissionRequestAlreadySent = 4;
           */
          value: CallError_PermissionRequestAlreadySent;
          case: 'permissionRequestAlreadySent';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.vcs.contract.CreatePermissionRequestResponse.
 * Use `create(CreatePermissionRequestResponseSchema)` to create a new message.
 */
export const CreatePermissionRequestResponseSchema: GenMessage<CreatePermissionRequestResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 22);

/**
 * @generated from message com.gem.vcs.contract.GetPermissionRequestsResponse
 */
export type GetPermissionRequestsResponse =
  Message<'com.gem.vcs.contract.GetPermissionRequestsResponse'> & {
    /**
     * @generated from oneof com.gem.vcs.contract.GetPermissionRequestsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.vcs.contract.GetPermissionRequestsSuccess success = 1;
           */
          value: GetPermissionRequestsSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.vcs.contract.GetPermissionRequestsResponse.
 * Use `create(GetPermissionRequestsResponseSchema)` to create a new message.
 */
export const GetPermissionRequestsResponseSchema: GenMessage<GetPermissionRequestsResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 23);

/**
 * @generated from message com.gem.vcs.contract.GetPermissionRequestsSuccess
 */
export type GetPermissionRequestsSuccess =
  Message<'com.gem.vcs.contract.GetPermissionRequestsSuccess'> & {
    /**
     * @generated from field: repeated int64 switchOnCamera = 1;
     */
    switchOnCamera: bigint[];

    /**
     * @generated from field: repeated int64 switchOnMic = 2;
     */
    switchOnMic: bigint[];

    /**
     * @generated from field: repeated int64 shareScreen = 3;
     */
    shareScreen: bigint[];
  };

/**
 * Describes the message com.gem.vcs.contract.GetPermissionRequestsSuccess.
 * Use `create(GetPermissionRequestsSuccessSchema)` to create a new message.
 */
export const GetPermissionRequestsSuccessSchema: GenMessage<GetPermissionRequestsSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 24);

/**
 * @generated from message com.gem.vcs.contract.UpdatePermissionRequestForMemberResponse
 */
export type UpdatePermissionRequestForMemberResponse =
  Message<'com.gem.vcs.contract.UpdatePermissionRequestForMemberResponse'> & {
    /**
     * @generated from oneof com.gem.vcs.contract.UpdatePermissionRequestForMemberResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.vcs.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.vcs.contract.UpdatePermissionRequestForMemberResponse.
 * Use `create(UpdatePermissionRequestForMemberResponseSchema)` to create a new message.
 */
export const UpdatePermissionRequestForMemberResponseSchema: GenMessage<UpdatePermissionRequestForMemberResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 25);

/**
 * @generated from message com.gem.vcs.contract.UpdatePermissionRequestForAllResponse
 */
export type UpdatePermissionRequestForAllResponse =
  Message<'com.gem.vcs.contract.UpdatePermissionRequestForAllResponse'> & {
    /**
     * @generated from oneof com.gem.vcs.contract.UpdatePermissionRequestForAllResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.vcs.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.ChannelDoesntExist channelDoesntExist = 2;
           */
          value: CallError_ChannelDoesntExist;
          case: 'channelDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForActionOnCall hasNoPermissionsForActionOnCall = 3;
           */
          value: CallError_HasNoPermissionsForActionOnCall;
          case: 'hasNoPermissionsForActionOnCall';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.vcs.contract.UpdatePermissionRequestForAllResponse.
 * Use `create(UpdatePermissionRequestForAllResponseSchema)` to create a new message.
 */
export const UpdatePermissionRequestForAllResponseSchema: GenMessage<UpdatePermissionRequestForAllResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 26);

/**
 * @generated from message com.gem.vcs.contract.GetCallByIdResponse
 */
export type GetCallByIdResponse = Message<'com.gem.vcs.contract.GetCallByIdResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.GetCallByIdResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallByIdSuccess success = 1;
         */
        value: GetCallByIdSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: CallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.GetCallByIdResponse.
 * Use `create(GetCallByIdResponseSchema)` to create a new message.
 */
export const GetCallByIdResponseSchema: GenMessage<GetCallByIdResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 27);

/**
 * @generated from message com.gem.vcs.contract.GetCallByIdSuccess
 */
export type GetCallByIdSuccess = Message<'com.gem.vcs.contract.GetCallByIdSuccess'> & {
  /**
   * @generated from field: com.gem.vcs.contract.Call call = 1;
   */
  call?: Call;
};

/**
 * Describes the message com.gem.vcs.contract.GetCallByIdSuccess.
 * Use `create(GetCallByIdSuccessSchema)` to create a new message.
 */
export const GetCallByIdSuccessSchema: GenMessage<GetCallByIdSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 28);

/**
 * @generated from message com.gem.vcs.contract.GetCallLinkResponse
 */
export type GetCallLinkResponse = Message<'com.gem.vcs.contract.GetCallLinkResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.GetCallLinkResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallLinkSuccess success = 1;
         */
        value: GetCallLinkSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.GetCallLinkResponse.
 * Use `create(GetCallLinkResponseSchema)` to create a new message.
 */
export const GetCallLinkResponseSchema: GenMessage<GetCallLinkResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 29);

/**
 * @generated from message com.gem.vcs.contract.GetCallLinkSuccess
 */
export type GetCallLinkSuccess = Message<'com.gem.vcs.contract.GetCallLinkSuccess'> & {
  /**
   * @generated from field: string callLink = 1;
   */
  callLink: string;
};

/**
 * Describes the message com.gem.vcs.contract.GetCallLinkSuccess.
 * Use `create(GetCallLinkSuccessSchema)` to create a new message.
 */
export const GetCallLinkSuccessSchema: GenMessage<GetCallLinkSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 30);

/**
 * @generated from message com.gem.vcs.contract.WaitingRoomAccessResponse
 */
export type WaitingRoomAccessResponse =
  Message<'com.gem.vcs.contract.WaitingRoomAccessResponse'> & {
    /**
     * @generated from oneof com.gem.vcs.contract.WaitingRoomAccessResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.vcs.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.WaitingRoomRequestDoesntExist waitingRoomRequestDoesntExist = 2;
           */
          value: CallError_WaitingRoomRequestDoesntExist;
          case: 'waitingRoomRequestDoesntExist';
        }
      | {
          /**
           * @generated from field: com.gem.vcs.contract.CallError.WaitingRoomRequestWasRejected waitingRoomRequestWasRejected = 3;
           */
          value: CallError_WaitingRoomRequestWasRejected;
          case: 'waitingRoomRequestWasRejected';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.vcs.contract.WaitingRoomAccessResponse.
 * Use `create(WaitingRoomAccessResponseSchema)` to create a new message.
 */
export const WaitingRoomAccessResponseSchema: GenMessage<WaitingRoomAccessResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 31);
